import { CommanderThunkAction } from '@mews-commander/types';
import { createAction } from '@mews/framework';
import { replace } from '@mews/routing';
import { removeUrlParam, setUrlParams } from '@mews-commander/utils';
import { getSortedAddressIdsByOwnerId } from '@mews-commander/legacy-entities/src/ducks';
import { getOwnerSortedFilesIds } from '@mews-commander/legacy-entities/src/ducks/files';
import { getSortedIdentityDocumentsByOwnerId } from '@mews-commander/legacy-entities/src/ducks/identityDocuments';
import { createPagination } from '../../pagination/actions';
import { CUSTOMER_DETAIL_TAB_CHANGED } from '../actionTypes';
import { CustomerDetailTabs } from '../enums';

const ADDRESSES_PAGE_SIZE = 3;
const DOCUMENTS_PAGE_SIZE = 3;
const FILES_PAGE_SIZE = 5;

export const createAddressPagination =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getSortedAddressIdsByOwnerId(getState(), { ownerId });
        return dispatch(createPagination(ids, ADDRESSES_PAGE_SIZE, `addresses-${scope}`));
    };

export const createIdentityDocumentsPagination =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getSortedIdentityDocumentsByOwnerId(getState(), { ownerId });
        return dispatch(createPagination(ids, DOCUMENTS_PAGE_SIZE, `identity-documents-${scope}`));
    };

export const createFilesPagination =
    (ownerId: string, scope: string): CommanderThunkAction =>
    (dispatch, getState) => {
        const ids = getOwnerSortedFilesIds(getState(), { ownerId });
        return dispatch(createPagination(ids, FILES_PAGE_SIZE, `files-${scope}`));
    };

export const changeTab =
    (valueTab: CustomerDetailTabs, scope: string, id: string): CommanderThunkAction =>
    (dispatch) => {
        if (valueTab !== CustomerDetailTabs.Billing) {
            dispatch(replace(removeUrlParam('billId')));
        }
        if (valueTab === CustomerDetailTabs.Profile) {
            dispatch(createAddressPagination(id, scope));
            dispatch(createIdentityDocumentsPagination(id, scope));
            dispatch(createFilesPagination(id, scope));
        }

        dispatch(replace(setUrlParams({ tab: valueTab })));

        return dispatch(createAction(CUSTOMER_DETAIL_TAB_CHANGED, valueTab, { scope }));
    };
